import { useEffect, useState } from "react";
import request from "../../../../helpers/request";
import endpoints from "../../../../helpers/endpoints";

const MIN_POSTCODE_LENGTH = 4;

export default function PostcodeSearchPanel({ onResults, searchPostcode, translations }) {
    const [postcode, setPostcode] = useState("");
    const [searching, setSearching] = useState(false);

    const isValid = postcode.trim().length >= MIN_POSTCODE_LENGTH;

    const search = (value) => {
        const pc = (value ?? postcode).trim();
        if (pc.length < MIN_POSTCODE_LENGTH || searching) return;

        setSearching(true);
        request(true).get(endpoints.FSA_MATCH_POSTCODE_SEARCH, { params: { postcode: pc } }).then(r => {
            onResults(r.data.rows);
        }).catch(e => {
            console.error(e);
        }).finally(() => {
            setSearching(false);
        });
    };

    useEffect(() => {
        if (searchPostcode) {
            setPostcode(searchPostcode);
            search(searchPostcode);
        }
    }, [searchPostcode]);

    return (
        <div className="grid grid-gap-15 postcode-search-panel">
            <h3>{translations['postcode_search'] ?? 'Postcode Search'}</h3>
            <div className="grid grid-columns-2 grid-gap-15" style={{ gridTemplateColumns: 'repeat(2, min-content)' }}>
                <input
                    type="text"
                    value={postcode}
                    onChange={(e) => setPostcode(e.target.value.toUpperCase())}
                    onKeyDown={(e) => e.key === "Enter" && search()}
                    placeholder="Enter postcode"
                    className="data-row-field"
                />
                <button
                    className={`button compact smaller-text colour-white ${isValid ? 'background-primary' : 'background-gray'}`}
                    style={{ width: '10em' }}
                    disabled={!isValid || searching}
                    onClick={() => search()}
                >
                    Search
                </button>
            </div>
        </div>
    )
}
